<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="12">
          <h3>Admin</h3>
        </v-col>
         <v-col cols="6">
          <admin-card
            path="/admin/users"
            title="Users"
            type="Admin"
            button="Manage"
            description="Manage the users"
          ></admin-card>
        </v-col>
        <v-col cols="6">
          <admin-card
            path="/admin/projects"
            title="Projects"
            type="Admin"
            button="Manage"
            description="Manage the projects on the platform"
          ></admin-card>
        </v-col>
        <v-col cols="6">
          <admin-card
            path="/admin/groups"
            title="Groups"
            type="Admin"
            button="Manage"
            description="Manage groups"
          ></admin-card>
        </v-col>
        
         <v-col cols="6">
             <admin-card
            path="/admin/exercises"
            title="Exercises"
            type="Admin"
            button="Manage"
            description="Manage the exercises"
          ></admin-card>
        </v-col>
            
       </v-row>
      <v-row>
         <v-col cols="12">
          <h3>Manage exercises</h3>
        </v-col>

  <v-col cols="6" v-for="ex in exercises" :key="ex.id">
          <admin-card
            :path="`/admin/${ex.slug}`"
            :title="ex.title"
            type="Admin"
            button="Manage"
            :description="ex.description"
          ></admin-card>
        </v-col>
       

       
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import{ AdminCard } from "@/components/core"
const fb = require("@/firebaseConfig.js");
export default {
  name: "AdminDashboard",
  components: {
    AdminCard
  },
  data() {
    return {
      exercises: null
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  mounted() {
    this.getExercises();
  },  
  methods: {
     getExercises() {
      fb.exercisesCollection
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          this.exercises = items;
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    }
  }
};
</script>
